import { render, staticRenderFns } from "./flex-collection.vue?vue&type=template&id=0e160c94&"
import script from "./flex-collection.vue?vue&type=script&lang=js&"
export * from "./flex-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports